module.exports = __webpack_public_path__ + "img/shutterstock_1351167989.11dd6043.jpg";